import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import authModule from "./auth.module";

export default new Vuex.Store({
    state: {
      activeUser: JSON.parse(localStorage.getItem("activeUser")) || {},
      activeCompany: JSON.parse(localStorage.getItem("activeCompany")) || {},
    },
    mutations: {
      UPDATE_ACTIVE_USER(state, user) {
        state.activeUser = { ...user };
        localStorage.setItem("activeUser", JSON.stringify(state.activeUser)); // persist
      },
      UPDATE_ACTIVE_COMPANY(state, company) {
        state.activeCompany = { ...company };
        localStorage.setItem("activeCompany", JSON.stringify(state.activeCompany)); // persist
      }
    },
    actions: {
      updateActiveUser({ commit }, user) {
        commit('UPDATE_ACTIVE_USER', user);
      },
      updateActiveCompany({ commit }, company) {
        commit('UPDATE_ACTIVE_COMPANY', company);
      }
    },
    modules: {
      auth: authModule,
    },
    strict: false,
});
